const vFilter = {
    formatDate: function (value, type) {
        if (value == null) {
            return null
        }
        if (!value) {
            return '--'
        }
        let date = new Date(value)
        let y = date.getFullYear()
        let MM = date.getMonth() + 1
        MM = MM < 10 ? '0' + MM : MM
        let d = date.getDate()
        d = d < 10 ? '0' + d : d
        let h = date.getHours()
        h = h < 10 ? '0' + h : h
        let m = date.getMinutes()
        m = m < 10 ? '0' + m : m
        let s = date.getSeconds()
        s = s < 10 ? '0' + s : s
        if (type === 'all') {
            return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
        } else if (type === 'day') {
            return MM + '.' + d
        } else if (type === 'hours') {
            return h + ':' + m
        } else if (type === 'y-m-d') {
            return y + '-' + MM + '-' + d
        }
    }
}
export default vFilter